// material ui
import { Theme } from '@mui/material';

export const dataGridCustomization = {
  MuiDataGrid: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        '&.MuiDataGrid-root': {
          borderRadius: '6px',
          // border: `1px solid ${theme.palette.divider}`,
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: '0px 5px 10px -3px rgba(0,0,0,0.1)',
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.grey[0]
              : theme.palette.grey[1000],
        },
        '& .MuiDataGrid-cell': {
          display: 'flex',
          alignItems: 'center',
        },
        '& .MuiDataGrid-columnHeader': {
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.grey[0]
              : theme.palette.grey[1000],
        },
        '.MuiDataGrid-cell--pinnedLeft': {
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.grey[0]
              : theme.palette.grey[1000],
        },
        '.MuiDataGrid-cell--pinnedRight': {
          backgroundColor:
            theme.palette.mode === 'light'
              ? theme.palette.grey[0]
              : theme.palette.grey[1000],
        },

        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 'bold',
        },

        // Focus outlines
        '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
          {
            outline: 'none',
          },

        // Selected row look (global version)
        '& .selected-row': {
          backgroundColor: theme.palette.action.selected,
          '&:hover': {
            backgroundColor: theme.palette.action.selected,
          },
        },
      }),
    },
  },
};
